/**
 * function to encode a string to base64
 * @param {string} data
 * @returns {string}
 */
export const encodeBase64 = data => {
  if (!data) {
    return '';
  }

  let encoded = data;

  try {
    encoded = btoa(data);
  } catch (e) {
    console.error(e, 'error encoding data');
  }

  return encoded;
};

/**
 * function to decode a base64 string
 * @param {string} data
 * @returns
 */

export const decodeBase64 = data => {
  if (!data) {
    return '';
  }

  let decoded = data;

  try {
    decoded = atob(data);
  } catch (e) {
    console.error(e, 'error decoding base64');
  }

  return decoded;
};
